import { render, staticRenderFns } from "./PackageDetail.vue?vue&type=template&id=da226b46&scoped=true&"
import script from "./PackageDetail.vue?vue&type=script&lang=js&"
export * from "./PackageDetail.vue?vue&type=script&lang=js&"
import style0 from "./PackageDetail.vue?vue&type=style&index=0&id=da226b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da226b46",
  null
  
)

export default component.exports